/** @format */
import Master from '../../Layouts/Master';
import { useLocation } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router';

import { EventContext } from '../../../Contexts/EventContext';
import useApi from '../../../Shared/hooks/api/Index';
import { error } from '../../../Shared/Components/Toast';
import Loading from '../../../Shared/Components/Loading';
import Pagination from '../../../Shared/Components/Pagination';
import useQuery from '../../../Shared/queryString';
import moment from 'jalali-moment';
import { baseApiUrl, number_format } from '../../../Shared/utils/helper';
import { Link } from 'react-router-dom';
import Datepicker from '../../../Shared/Components/Datepicker';

const Transaction = () => {
	const eventContext = useContext(EventContext);
	const { search } = useLocation();
	const transactionTracking = useQuery.getParam('transaction_tracking');
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [, setIssueTracking] = useState('');
	const [fromDate, setFromDate] = useState('');
	const [toDate, setToDate] = useState('');
	const [natCode, setNatCode] = useState('');
	const [status, setStatus] = useState('');

	useEffect(() => {
		const params = new URLSearchParams(search);
		// تاریخ در URL شمسی است (مثل 1405/4/1) — بدون تبدیل میلادی
		setFromDate(params.get('start') || '');
		setToDate(params.get('end') || '');
		setStatus(params.get('status') || '');
		setNatCode(params.get('nat_code') || '');

		if (transactionTracking !== null) {
			setIssueTracking(transactionTracking);
		}
		getTransaction();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [search]);
	const getTransaction = async () => {
		setLoading(true);
		await useApi.get(
			`/panel/report/payment${search}`,
			{},
			(res) => {
				eventContext.transactions = res.data;
				setLoading(false);
			},
			(err) => {
				setLoading(false);
				error('هنگام دریافت اطلاعات خطایی رخ داده است');
			},
		);
	};

	const getFileterParams = () => {
		let start = fromDate.length > 0 ? '&start=' + fromDate : '';
		let end = toDate.length > 0 ? '&end=' + toDate : '';
		let nat_code = natCode.length > 0 ? '&nat_code=' + natCode : '';
		let statusCode = status.length > 0 ? '&status=' + status : '';

		let query = '';
		query += query.length > 0 ? start : start.replace('&', '');
		query += query.length > 0 ? end : end.replace('&', '');
		query += query.length > 0 ? nat_code : nat_code.replace('&', '');
		query += query.length > 0 ? statusCode : statusCode.replace('&', '');

		return query;
	}

	const searchPayment = () => {
		let query = getFileterParams();
		return navigate(`/panel/reports/all-payments?${query}`);
	};

	const exportPayments = async () => {
		const fromUrl = (search || '').replace(/^\?/, '');
		const fromForm = getFileterParams().replace(/^&/, '');
		const query = fromUrl || fromForm;
		const url = `${baseApiUrl()}/panel/report/payment/excel/export${
			query ? `?${query}` : ''
		}`;
		try {
			await useApi.downloadFile(url);
		} catch (err) {
			error('هنگام دریافت خروجی اکسل خطایی رخ داده است');
		}
	};
	return loading ? (
		<Loading />
	) : (
		<Master>
			<div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
				<div className='d-flex flex-row mt-2'>
					<i className='fad fa-list f-20 text-secondary mx-2'></i>
					<h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
						لیست تراکنش ها
					</h1>
				</div>
			</div>
			<div className='d-flex flex-row w-100 my-1'>
				<div className='form-group d-flex flex-column mx-2'>
					<label>از</label>
					<Datepicker
						handleChange={(name, value) => setFromDate(value)}
						name='start'
						value={fromDate}
					/>
				</div>
				<div className='form-group d-flex flex-column mx-2'>
					<label>تا</label>
					<Datepicker
						handleChange={(name, value) => setToDate(value)}
						name='end'
						value={toDate}
					/>
				</div>
				<div className='form-group d-flex flex-column mx-2'>
					<label>وضعیت</label>
					<select
						className='form-control'
						value={status}
						onChange={(e) => setStatus(e.target.value)}>
						<option value="">
							وضعیت...
						</option>
						<option value='1'>موفق</option>
						<option value='2'>نا موفق</option>
					</select>
				</div>
				<div className='form-group'>
					<label>کد ملی</label>
					<input
						type='text'
						value={natCode}
						onChange={(e) => setNatCode(e.target.value)}
						className='form-control'
					/>
				</div>
				<div className='form-group mx-2 mt-1'>
					<button
						onClick={searchPayment}
						className='btn bg-purple f-12 mt-4 mx-2 text-dark-mode'>
						جستجو
					</button>
				</div>
				<div className='form-group mx-2 mt-1'>
					<button
						type='button'
						onClick={exportPayments}
						className='btn bg-purple f-12 mt-4 mx-2 text-dark-mode'>
						خروجی اکسل
					</button>
				</div>
			</div>
			<div className='w-100 overflow-auto'>
				{eventContext.transactions?.data?.length > 0 ? (
					<table className='table table-hover'>
						<thead>
							<tr>
								<th>#</th>
								<th>نام و نام خانوادگی</th>
								<th>کد ملی</th>
								<th>موبایل</th>
								<th>تاریخ</th>
								<th>مبلغ (ریال) </th>
								<th>شماره سفارش </th>
								<th>شماره پیگیری</th>
								<th>توضیحات</th>
								<th>وضعیت تراکنش</th>
								<th>فاکتور</th>
							</tr>
						</thead>
						<tbody>
							{eventContext.transactions?.data?.map((item) => (
								<tr key={item.id}>
									<th>{item.id}</th>
									<td>
										{item?.user?.name ?? ''} {item?.user?.last_name ?? '-'}
									</td>
									<td>{item?.user?.national_card_id}</td>
									<td>{item?.user?.mobile}</td>
									<td>
										{moment(item.created_at ?? '1990-01-01', 'YYYY-MM-DD')
											.locale('fa')
											.format('YYYY/MM/DD')}
									</td>
									<td>{number_format(item?.amount)}</td>
									<td>{item?.order_id}</td>
									<td>{item?.tracking_id}</td>
									<td>{item?.description}</td>

									<td>
										{item?.status === 2 ? (
											<span className='badge badge-danger badge-pill p-2'>
												ناموفق
											</span>
										) : item?.status === 1 ? (
											<span className='badge badge-success badge-pill p-2'>
												موفق
											</span>
										) : null}
									</td>
									<td>
										{item?.has_factor && item?.status === 1 ? (
											<Link
												to={`/panel/reports/payment-factor/${item?.paymentable_id}/payment/${item.id}`}>
												مشاهده فاکتور
											</Link>
										) : (
											<span className="text-muted f-12">—</span>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div className='d-flex flex-row justify-content-center border p-3 my-3	'>
						<i className='fad fa-plus f-16 mx-2 text-secondary'></i>
						<span className='f-13 font-weight-bold text-secondary'>
							تراکنشی وجود ندارد
						</span>
					</div>
				)}
			</div>

			<div className='w-100 mt-4 d-flex'>
				<Pagination
					totalPage={eventContext.transactions?.meta?.pagination?.total_pages}
					basePath={`/panel/reports/all-payments${getFileterParams().length > 0 ? `?${getFileterParams()}` : ''}`}
				/>
			</div>
		</Master>
	);
};

export default Transaction;
